import axios from 'axios';

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:8000/api/',
    baseURL: 'https://5s.wanorn.com/backend/api/',
    // headers: {
    //     Authorization: 'Bearer jcv9NzDHK5DOSFwggeHoSdYocQ6JDY7c1ALF5Guu5b64de5b',
    // },
    maxBodyLength: Infinity,
});

export default axiosInstance;